<ng-container *mojoHasPrivilege="privileges.candidates.badges">
  <ng-container *ngIf="!inline">
    <mat-icon
      *ngIf="favorite"
      class="favorite"
      data-cy="candidate-badges-favorite-badge"
    >favorite</mat-icon>
    <mat-icon
      *ngIf="silver"
      class="silver"
      data-cy="candidate-badges-silver-badge"
    >star_rate</mat-icon>
    <mat-icon
      *ngIf="alumni"
      class="alumni"
    >school</mat-icon>
    <mat-icon
      *ngIf="warning"
      class="warning"
      data-cy="candidate-badges-warning-badge"
    >warning</mat-icon>
  </ng-container>

  <ng-container *ngIf="inline">
    <div
      *ngIf="favorite"
      class="mat-caption favorite"
      data-cy="candidate-badges-favorite-badge"
    >
      <mat-icon class="favorite">favorite</mat-icon>
      <span>FAVORITE</span>
    </div>
    <div
      *ngIf="silver"
      class="mat-caption silver"
      data-cy="candidate-badges-silver-badge"
    >
      <mat-icon class="silver">star_rate</mat-icon>
      <span>SILVER MEDALIST</span>
    </div>
    <div
      *ngIf="alumni"
      class="mat-caption alumni"
    >
      <mat-icon class="silver">school</mat-icon>
      <span>ALUMNI</span>
    </div>
    <div
      *ngIf="warning"
      class="mat-caption warning"
      data-cy="candidate-badges-warning-badge"
    >
      <mat-icon class="warning">warning</mat-icon>
      <span>WARNING</span>
    </div>
  </ng-container>
</ng-container>
